import { render, staticRenderFns } from "./AddTransaction.vue?vue&type=template&id=a16302e0&scoped=true"
import script from "./AddTransaction.vue?vue&type=script&lang=js"
export * from "./AddTransaction.vue?vue&type=script&lang=js"
import style0 from "./AddTransaction.vue?vue&type=style&index=0&id=a16302e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a16302e0",
  null
  
)

export default component.exports